import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    navigationOpen: false,
    overlayId: 'none',
    prevPage: '/',
    stickyActivated: false,
    pwReset: false,
    emailAddress: '',
    firstName: localStorage.getItem('first_name'),
    lastName: localStorage.getItem('last_name'),
    accessToken: localStorage.getItem('auth-token'),
    tokenExpiry: localStorage.getItem('auth_ttl'),
    isLoggedIn: Date.now() < parseInt(localStorage.getItem('auth_ttl')),
    axiosConfig: {
      headers: { Authorization: 'Bearer ' }
    },
    specialties: [
      'Pediatrics',
      'Adolescent Medicine',
      'Adult Care',
      'Family Practice',
      'Dermatology',
      'General Practice',
      'Hepatology',
      'Other'
    ]
  },
  getters: {
    LOGGED_IN (state) {
      return state.isLoggedIn
    },
    getField
  },
  mutations: {
    START_STICKY (state) {
      state.stickyActivated = window.screen.width > 767
    },
    SET_OVERLAY (state, overlayId) {
      state.overlayId = overlayId
    },
    SET_PREV_PAGE (state, path) {
      state.prevPage = path
    },
    SET_TOKEN (state, payload) {
      state.accessToken = payload.token
      state.tokenExpiry = payload.expires_in
      state.firstName = payload.first_name
      state.axiosConfig.headers.Authorization = 'Bearer ' + payload.token
      state.isLoggedIn = true
      window.localStorage.setItem('auth_token', payload.token)
      window.localStorage.setItem('auth_ttl',
        Date.now() + 1000 * payload.expires_in)
      window.localStorage.setItem('first_name', payload.first_name)
      window.localStorage.setItem('login_email', payload.email)
    },
    LOGOUT (state) {
      state.accessToken = null
      state.tokenExpiry = 0
      state.axiosConfig.headers.Authorization = ''
      window.localStorage.removeItem('auth_token')
      window.localStorage.setItem('auth_ttl', 0)
      window.localStorage.removeItem('first_name')
      window.localStorage.removeItem('last_name')
      window.localStorage.removeItem('login_email')
      state.emailAddress = ''
      state.firstName = ''
      state.isLoggedIn = false
    },
    updateField
  },
  actions: {},
  modules: {}
})
